/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/volume_on_medium'
export default icon
